import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { useAuthStore } from '../../app/store/auth-store';
import { Users, Shield, Plus } from 'lucide-react';

export const QuickActions: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { hasPermission } = useAuthStore();

  const actions = [
    {
      key: 'createUser',
      label: t('users.createUser'),
      icon: <Plus className="h-4 w-4" />,
      onClick: () => navigate('/users?action=create'),
      permission: 'users:write',
      variant: 'default' as const,
    },
    {
      key: 'manageUsers',
      label: t('users.title'),
      icon: <Users className="h-4 w-4" />,
      onClick: () => navigate('/users'),
      permission: 'users:read',
      variant: 'outline' as const,
    },
    {
      key: 'createRole',
      label: t('roles.createRole'),
      icon: <Plus className="h-4 w-4" />,
      onClick: () => navigate('/roles?action=create'),
      permission: 'roles:write',
      variant: 'default' as const,
    },
    {
      key: 'manageRoles',
      label: t('roles.title'),
      icon: <Shield className="h-4 w-4" />,
      onClick: () => navigate('/roles'),
      permission: 'roles:read',
      variant: 'outline' as const,
    },
  ];

  const availableActions = actions.filter(action => hasPermission(action.permission));

  if (availableActions.length === 0) {
    return null;
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-lg font-semibold">
          {t('dashboard.quickActions')}
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-4">
          {availableActions.map((action) => (
            <Button
              key={action.key}
              variant={action.variant}
              onClick={action.onClick}
              className="justify-start"
            >
              {action.icon}
              {action.label}
            </Button>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};